import React, { useState } from 'react';

import {
  Navbar, NavbarToggler, Collapse, Nav, NavItem, UncontrolledCollapse,
} from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

import { LanguageConsumer } from '../../config/LanguageContext';
import Avatar from '../../components/Avatar';
import SmartConsentLogo from '../../components/SmartConsentLogo';
import stringTable from '../../config/stringTable';

import './header.scss';

const getInitials = (user) => {
  let initials = <FontAwesomeIcon icon="user" color="white" />;

  if (user.given_name && user.given_name[0]) {
    [initials] = user.given_name;
  }

  if (user.family_name && user.family_name[0]) {
    initials += user.family_name[0];
  }

  return initials;
};

export default function Header(props) {
  const [collapsed, setCollapsed] = useState(true);

  const toggleNavbar = () => setCollapsed(!collapsed);
  if (props.hide) return null;

  return (
    <Navbar color="white" light expand="bg-light" className="row header" fixed="top">
      <div className="headerContent px-2">
        <Avatar show={props.isSignedIn}>
          {getInitials(props.user)}
        </Avatar>
        <SmartConsentLogo />
        <NavbarToggler onClick={toggleNavbar} aria-label="Options Menu" aria-expanded={!collapsed} />
      </div>
      <Collapse isOpen={!collapsed} navbar>
        <LanguageConsumer>
          {({ onUpdateLanguage, language }) => {
            const updateLanguage = (newLang) => {
              onUpdateLanguage(newLang, props);
              setCollapsed(true);
            };
            return (
              <Nav navbar>
                <NavItem className="nav-link pb-0">
                  <button
                    id="toggler"
                    type="button"
                    tabIndex="0"
                    onKeyDown={(event) => {
                      // Check for Enter or Space key (standard accessibility keys)
                      if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault(); // Prevent default behavior like page scrolling

                        // Create a new click event
                        const clickEvent = new MouseEvent('click', {
                          bubbles: true,
                          cancelable: true,
                          view: window,
                        });

                        // Dispatch the click event
                        event.target.dispatchEvent(clickEvent);
                      }
                    }}
                  >
                    Select Language
                  </button>
                  <UncontrolledCollapse toggler="#toggler" className="languageContainer">
                    <div role="listbox" aria-label="Language Options">
                      <button
                        role="option"
                        aria-selected={language === 'en'}
                        className={`lang-option ${(language === 'en') && 'active'}`}
                        type="button"
                        onClick={() => updateLanguage('en')}
                        onKeyPress={() => updateLanguage('en')}
                      >
                        English
                      </button>
                      <button
                        role="option"
                        aria-selected={language === 'fr'}
                        className={`lang-option ${(language === 'fr') && 'active'}`}
                        type="button"
                        onClick={() => updateLanguage('fr')}
                        onKeyPress={() => updateLanguage('fr')}
                      >
                        Français
                      </button>
                    </div>
                  </UncontrolledCollapse>
                </NavItem>
                {
                props.isSignedIn && (
                  <NavItem>
                    <Link to="/signout" onClick={toggleNavbar} className="nav-link">
                      {stringTable[language]['Log Out']}
                    </Link>
                  </NavItem>
                )
              }
              </Nav>
            );
          }}
        </LanguageConsumer>
      </Collapse>
    </Navbar>
  );
}
